import {stringISOtoUS} from "../../../date-converter";

export const buildOperatingDataRow = function(operationData, commencementHiddenState=false) {
    return {
        valueCells: [{
            // Years
            editable: true,
            type: 'text',
            value: operationData.years || '',
            hasRowManipulation: true,
        }, {
            // Commencement
            editable: true,
            type: 'date',
            hidden:commencementHiddenState,
            value: operationData.lease_commencement ? stringISOtoUS(operationData.lease_commencement) : '',
        }, {
            // Annual Rent
            editable: false,
            type: 'number',
            unit: '$',
            tooltip: '= rent_schedule_monthly * 12',
            changedValue:"",
            getComputedValue(tables, i) {
                const index = parseInt(i);
                if (!tables['rent-schedule'].rows[index])
                    return {internalValue: null, displayValue: ''};

                // const calculatedValueByRentPsf = tables['annualized-operating-data'].rows[0].valueCells[2].changedValue;
                if(this.changedValue && index==0){
                    const value = parseInt(this.changedValue);
                    return {internalValue: value, displayValue: `$${value.toLocaleString()}`};
                }

                if (index === 0) {
                    const monthlyRentSchedule = parseFloat(tables['rent-schedule'].rows[index].valueCells[0].value);
                    if (!isFinite(monthlyRentSchedule)) {
                        return {internalValue: null, displayValue: ''};
                    }
                    const value = parseInt(monthlyRentSchedule * 12);
                    return {internalValue: value, displayValue: `$${value.toLocaleString()}`};
                }

                const monthlyRentSchedule = parseFloat(tables['rent-schedule'].rows[index].valueCells[0].value);
                if (!isFinite(monthlyRentSchedule)) {
                    return {internalValue: null, displayValue: ''};
                }

                const value = monthlyRentSchedule ? parseInt(monthlyRentSchedule * 12) : 0;
                return {internalValue: value, displayValue: `$${value.toLocaleString()}`};
            },
        }, {
            // Increase
            editable: false,
            type: 'number',
            unit: '%',
            tooltip: '= annual_rent / previous_annual_rent - 1',
            getComputedValue(tables, i) {
                const index = parseInt(i);
                if (!tables['annualized-operating-data'].rows[index])
                    return {internalValue: null, displayValue: ''};

                if (index === 0)
                    return {internalValue: null, displayValue: '-'};

                const monthlyRentSchedule = parseFloat(tables['rent-schedule'].rows[index].valueCells[0].value);
                let value = null;
                let displayValue = '-';
                if (monthlyRentSchedule && isFinite(monthlyRentSchedule)) {
                    const previousAnnualRent = tables['annualized-operating-data'].rows[index - 1].valueCells[2].getComputedValue(tables, index - 1).internalValue;
                    const currentAnnualRent = tables['annualized-operating-data'].rows[index].valueCells[2].getComputedValue(tables, index).internalValue;
                    value = parseFloat((currentAnnualRent / previousAnnualRent - 1) * 100);
                    displayValue = value && isFinite(value) ? `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%` : '-';
                }
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // leave ARCIMEDES_ROW_ID as the last cell
            type: 'string',
            hidden: true,
            value: operationData.arcimedes_row_id || '',
        },]
    }
};

export default {
    name: 'ANNUALIZED OPERATING DATA',

    headerRow: ['Years',  'Annual Rent', 'Increase'],
    footerRow: [{
        valueCells: [{
            editable: false,
            getComputedValue() {
                return {displayValue: 'NET OPERATING INCOME'}
            }
        }, {
            hasExpandButton: true,
        }, {
            editable: false,
            getComputedValue(tables) {
                return tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables);
            }
        }, null]
    }, {
        valueCells: [{
            editable: true,
            type: 'text',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }, {
            editable: true,
            unit: '$',
            type: 'number',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }]
    }, {
        valueCells: [{
            editable: true,
            type: 'text',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }, {
            editable: true,
            unit: '$',
            type: 'number',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }]
    }, {
        valueCells: [{
            editable: true,
            type: 'text',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }, {
            editable: true,
            unit: '$',
            type: 'number',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }]
    }, {
        valueCells: [{
            editable: true,
            type: 'text',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }, {
            editable: true,
            unit: '$',
            type: 'number',
            value: '',
            hidden: true,
        }, {
            empty: true,
            hidden: true,
        }]
    }],
    rows: {},
};